import getCurrentMainDomain from '@helpers/misc/domain/getCurrentMainDomain'
import getEnv from '@providers/getEnv'

const MAP_TILER_WEB_COMPONENTS_TOKEN = 'iUzDOAFCUx33tmT6OCea'

const providers = {
  openStreetMap: {
    attribution:
      '\u003ca href="https://www.maptiler.com/copyright/" target="_blank"\u003e\u0026copy; MapTiler\u003c/a\u003e \u003ca href="https://www.openstreetmap.org/copyright" target="_blank"\u003e\u0026copy; OpenStreetMap contributors\u003c/a\u003e',
    minZoom: 1,
    crossOrigin: true,
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
  },
  mapTiler: {
    attribution:
      '\u003ca href="https://www.maptiler.com/copyright/" target="_blank"\u003e\u0026copy; MapTiler\u003c/a\u003e \u003ca href="https://www.openstreetmap.org/copyright" target="_blank"\u003e\u0026copy; OpenStreetMap contributors\u003c/a\u003e',
    tileSize: 512,
    zoomOffset: -1,
    minZoom: 1,
    crossOrigin: true,
    url: `https://api.maptiler.com/maps/streets/{z}/{x}/{y}@2x.png?key=${MAP_TILER_WEB_COMPONENTS_TOKEN}`
  }
}

let provider = null

export default function getLeaftletProvider() {
  if (!provider) {
    if (getEnv() === 'prod' && getCurrentMainDomain() !== 'bejusto.com') {
      provider = providers.mapTiler
    } else {
      provider = providers.openStreetMap
    }
  }
  return provider
}
